export default "__VITE_ASSET__146bdef5__"